export default __webpack_public_path__ + "static/media/mountains.03b04c6a.jpg";